import React, { useMemo } from 'react';
import PageTitle from 'common/components/PageTitle';
import { ApiAdminV1RecommendationTemplateListApiArg } from 'store/generated/admin/templates';
import { useNavigate } from 'react-router-dom';
import { templatesApi } from '../api/recommendation-templates';
import { TeamRecommendationListTable } from './TeamRecommendationListTable';

const TeamRecommendationList = () => {
  const [triggerDelete] = templatesApi.useApiAdminV1RecommendationTemplateDestroyMutation();

  const navigate = useNavigate();
  const { teamRecommendations, orgGoals, isLoading, error } =
    templatesApi.useApiAdminV1RecommendationTemplateListQuery(
      {} as ApiAdminV1RecommendationTemplateListApiArg,
      {
        selectFromResult: res => ({
          orgGoals:
            res.data
              ?.filter(x => x.type_of === 1)
              .map(x => ({
                id: x.id,
                name: x.name,
                target: x.target,
              })) ?? [],
          teamRecommendations: res.data?.filter(x => x.type_of === 2) ?? [],
          isLoading: res.isLoading,
          error: res.error,
        }),
      }
    );

  const navigateToDetails = (teamProjectId?: number) => {
    if (teamProjectId) {
      navigate(`/settings/admin/recommendation-templates/team-recs/details/${teamProjectId}`, {
        state: orgGoals,
      });
    } else {
      navigate(`/settings/admin/recommendation-templates/team-recs/details/create`, {
        state: orgGoals,
      });
    }
  };

  const onItemDeleteConfirm = (id: number) => {
    triggerDelete({ id });
  };

  const teamProjects = useMemo(() => {
    if (!teamRecommendations) return [];

    return teamRecommendations
      ?.slice()
      .sort((a, b) => a?.template?.title.localeCompare(b?.template?.title));
  }, [teamRecommendations]);

  return (
    <>
      <TeamRecommendationListTable
        title="Team Project Templates"
        projects={teamProjects}
        goals={orgGoals}
        isLoading={isLoading}
        error={error}
        onItemDeleteConfirm={onItemDeleteConfirm}
        onItemClick={navigateToDetails}
        onAddClick={() => navigateToDetails(undefined)}
      />
    </>
  );
};

export default TeamRecommendationList;
